import { Instagram, Mail, Star } from "lucide-react";
import { BRAND } from "@/data";

export default function Footer() {
  return (
    <footer className="relative border-t border-[#C9A24B]/15 bg-[#140B09] py-14" data-testid="site-footer">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10 flex flex-col items-center text-center gap-6">
        <Star className="w-4 h-4 text-[#C9A24B]" fill="#C9A24B" strokeWidth={0} />
        <div className="font-display uppercase tracking-[0.3em] text-lg text-[#EFE3CC]">{BRAND.name}</div>
        <p className="text-xs tracking-[0.25em] uppercase text-[#B7A488]">{BRAND.tagline}</p>
        <p className="text-xs tracking-[0.2em] uppercase text-[#7a6a55]" data-testid="footer-location">Charlotte, North Carolina</p>

        <div className="flex items-center gap-8 mt-2">
          <a href="#contact" data-testid="footer-email" className="flex items-center gap-2 text-sm text-[#B7A488] hover:text-[#E9D3A0] transition-colors">
            <Mail className="w-4 h-4" strokeWidth={1.5} /> Message
          </a>
          <a href="#" data-testid="footer-instagram" className="flex items-center gap-2 text-sm text-[#B7A488] hover:text-[#E9D3A0] transition-colors">
            <Instagram className="w-4 h-4" strokeWidth={1.5} /> Instagram
          </a>
        </div>

        <div className="hairline w-full max-w-md mt-6" />
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 text-[11px] text-[#7a6a55]">
          <span>© {new Date().getFullYear()} {BRAND.name}. All whispers reserved.</span>
          <span>Offered for reflection & entertainment.</span>
          <a href="/admin" data-testid="footer-portal" className="hover:text-[#C9A24B] transition-colors">Portal</a>
        </div>
      </div>
    </footer>
  );
}
